import nBossConnection from 'modules/base/service/nBossConnection';
import UserDto from 'app/admin/user/dto/UserDto';

class AccessManagementService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'accessManagement';
	}

	/**
		* Backend returns a "state" wrapper (userGroups/userGroupId/roles/role/meta/client...).
		* Keep this as raw DTO to avoid mismatches with older getLoggedInClient responses.
		* @return {Promise<Object|null>}
		*/
	getState() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getState`)
				.then(response => resolve(response?.data ?? null))
				.catch(reject);
		});
	}

	/**
	* @deprecated use getState()
	* @return {Promise<UserDto|null>}
	*/
	getLoggedInClient() {
		return new Promise((resolve, reject) => {
			this.getState()
				.then((stateDto) => {
					const client = stateDto && typeof stateDto === 'object' && stateDto.client && typeof stateDto.client === 'object'
						? stateDto.client
						: (stateDto && typeof stateDto === 'object' && (stateDto.email != null || stateDto.name != null) ? stateDto : null);
					resolve(client ? new UserDto().setup(client) : null);
				})
				.catch(reject);
		});
	}

	/**
	* @return {Promise<string>}
	*/
	getLoggedInClientName() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getLoggedInClientName`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	* @return {Promise<string>}
	*/
	getRole() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getRole`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}


	/**
	* @param {string} role
	* @return {Promise<boolean>}
	*/
	changeRole(role) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/changeRole`, { role })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	* @return {Promise<number>}
	*/
	getUserGroupId() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getUserGroupId`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	* @param {number} id
	* @return {Promise<boolean>}
	*/
	changeUserGroup(userGroupId) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/changeUserGroup`, { userGroupId })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	* @return {Promise<boolean>}
	*/
	logout() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/logout`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	* @return {Promise<boolean>}
	*/
	isLoggedIn() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/isLoggedIn`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new AccessManagementService();